import $ from "jquery";
import Alert from "../ui/Alert";
import { Modal } from 'bootstrap';

$(function () {
    const appFormSubmit = document.querySelector('.app-form-submit');
    const successModalEl = document.querySelector('#successModal');
    if (!appFormSubmit || !successModalEl) {
        return;
    }

    const $successModal = new Modal(successModalEl);

    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.addedNodes.length && mutation.addedNodes[0].classList?.contains('subscribe-form-success')) {
                $successModal.show();

                setTimeout(() => {
                    $successModal.hide();
                }, 5000);
            }
        });
    });

    observer.observe(appFormSubmit, { childList: true });
});
